import { Component, HostListener, ViewContainerRef } from '@angular/core';
import { OnInit } from '@angular/core';
import { Services } from './app.service';
import { SecurityManager } from './app.sec.component';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

declare var $: any;
declare var moment: any;
@Component({
    providers: [Services, SecurityManager],
    templateUrl: './profile.component.html'
})
export class ProfileComponent implements OnInit {

    profile = {
        LastName: null,
        Mobile: null,
        Email: null,
        FirstName: null,
        Sessions: null,
    };
    currentSession = null;
    showConfrimModal = false;
    sessionToDelete = null;
    constructor(public toastr: ToastsManager, vcr: ViewContainerRef, private services: Services,
        private security: SecurityManager, private router: Router) {

        this.toastr.setRootViewContainerRef(vcr);

    }

    getProfile = function () {
        $('.PageLoading').slideDown()
        this.services.getProfile().subscribe(
            (data) => { this.profile = data; $('.PageLoading').slideUp() },
            (err) => { this.error = err; $('.PageLoading').slideUp() });
    }

    onReturnClick() {
        this.router.navigateByUrl('home/cards');

    }
    onTerminateSessionClick(token) {
        this.sessionToDelete = { Token: token, UserID: this.currentSession.UserID };

        this.showConfrimModal = true;


    }

    onConfrimSessionDelete() {
        $('.PageLoading').slideDown()
        this.services.terminateSession(this.sessionToDelete).subscribe(
            (data) => {
                $('.PageLoading').slideUp()
                this.toastr.success('تغییرات با موفقیت  ذخیره شد.', 'عملیات موفق');
                this.showConfrimModal = false;
                this.getProfile();
            },
            (err) => {
                $('.PageLoading').slideUp()
                this.toastr.error('مشکلی در سامانه رخ داده است.', 'عملیات ناموفق');


            });
    }

    saveProfile = function () {
        delete this.profile.RMessage;
        delete this.profile.RStatus;
        $('.PageLoading').slideDown()

        this.services.setProfile(this.profile).subscribe(
            (data) => {
                this.toastr.success('تغییرات با موفقیت  ذخیره شد.', 'عملیات موفق');
                $('.PageLoading').slideUp()

            },
            (err) => {
                this.toastr.error('مشکلی در سامانه رخ داده است.', 'عملیات ناموفق');
                $('.PageLoading').slideUp()
                this.error = err
            });
    }
    ngOnInit() {

        this.currentSession = this.security.getToken();

        if (this.security.checkToken()) {
            this.getProfile();
        }

    }





}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/profile.component.ts